import './categories/category_list.scss'
import React, {useState, useEffect} from 'react';
import {PropTypes} from 'prop-types';
import CloseIcon from '../assets/close_S.svg';

const Survey = function (props) {
    const iframeUrl = document.location.href.split('#')[0].split('?')[0].replace('index.html', '') +
            'survey.html';
    const height = Math.min(700, 0.7 * window.innerHeight);
    
    // by initially set the bottom negative (out of screen) and immidiately after updating it, the css
    // transition will animate the panel
    const [bottom, setButtom] = useState(-height);
    useEffect(() => {
        setButtom(5);
    }, []);

    const closePanel = () => {
        localStorage.setItem('permits-survey-done', true);
        // slide out the button first, then remove it
        setButtom(-height);
        setTimeout(() => {
            props.onClose();
        }, 500);
    }

    return <div id="survey" style={{bottom}}>
        <div className="survey-header">
            {/* <h2>Please share your feedback</h2> */}
            <span onClick={closePanel}>
                <img src={CloseIcon} alt="close"/>
            </span>
        </div>
        <iframe src={iframeUrl} title="Survey" height={height} style={{border: 'none'}} width="100%"/>
    </div>
};

Survey.propTypes = {
    onClose: PropTypes.func.isRequired
};

export {Survey};
